import * as yup from "yup";
import { addKeyToFieldsRecursively } from "@/react/schema/schemaFields";

const schema = yup.object({
  subscriptionId: yup.string().nullable(),
  extensionNumber: yup.string().nullable(),
  callerIdFirstName: yup.string().nullable(),
  callerIdLastName: yup.string().nullable(),
  primaryDID: yup.string().nullable(),
  details: yup.object({
    maxConcurrentCalls: yup
      .number()
      .nullable()
      .min(1, "Cannot go below 1")
      .max(10, "Cannot go above 10"),
  }),
});

addKeyToFieldsRecursively(schema);

export default schema;
